import { MenuItem, Select } from "@mui/material";
import { autoFormatCamelCase } from "@entrilia/shared/utilities/stringHelper";
import type { NumberScaleFormat } from "../../../../../api/types/objectTypes";

interface Props {
  value: NumberScaleFormat | undefined;
  options: readonly NumberScaleFormat[];
  disabled?: boolean;
  onChange: (value: NumberScaleFormat | undefined) => void;
}

const ScaleFormatSelect = ({ value, options, disabled, onChange }: Props) => {
  return (
    <Select<NumberScaleFormat | "">
      displayEmpty
      disabled={disabled}
      value={value ?? ""}
      onChange={(e) => {
        onChange(e.target.value || undefined);
      }}
      sx={{ width: "12rem" }}
    >
      <MenuItem value="">None</MenuItem>
      {options.map((format) => (
        <MenuItem key={format} value={format}>
          {autoFormatCamelCase(format)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ScaleFormatSelect;
